module.exports = __webpack_public_path__ + "img/icon_duoduo.49e55ef4.png";